import VueI18n from 'vue-i18n';
import lodash from 'lodash';
import getBrowserLocale from "@/services/getBrowserLocale";
import {supportedLocalesInclude} from "@/services/supportedLocalesInclude";

function getStartingLocale() {
    const browserLocale = getBrowserLocale({ countryCodeOnly: true })

    if (supportedLocalesInclude(browserLocale)) {
        return browserLocale
    } else {
        return process.env.VUE_APP_I18N_LOCALE || "en"
    }
}

const Translations = (messages: { [key: string]: string | any }) => new VueI18n({
    locale: getStartingLocale(),
    fallbackLocale: 'en',
    pluralizationRules: {
        sk: (choice, choicesLength) => {
            if (choice === 0 || choicesLength === 1) {
                return 0;
            }

            if (choice === 1 && choicesLength > 1) {
                return 1;
            }

            if (choice > 1 && choice < 5 && choicesLength > 2) {
                return 2;
            }

            if (choice >= 5 && choicesLength > 3) {
                return 3;
            }

            return 0;
        },
    },

    messages: lodash.merge(
        {
            sk: {
                Basic: {
                    words: {
                        serialNumberDay: '{day}. deň',
                        and: 'a',
                        year: '{n} rokov | {n} rok | {n} roky | {n} rokov',
                        month: '{n} mesiacov | {n} mesiac | {n} mesiace | {n} mesiacov',
                        monthly: 'mesačne',
                    },
                    mark: {
                        leftParenthesis: '(',
                        rightParenthesis: ')',
                    },
                },

                Date: {
                    day: 'dňa',
                    month: {
                        1: {
                            short: 'Jan',
                            long: 'Január',
                        },

                        2: {
                            short: 'Feb',
                            long: 'Február',
                        },

                        3: {
                            short: 'Mar',
                            long: 'Marec',
                        },

                        4: {
                            short: 'Apr',
                            long: 'Apríl',
                        },

                        5: {
                            short: 'Máj',
                            long: 'Máj',
                        },

                        6: {
                            short: 'Jún',
                            long: 'Jún',
                        },

                        7: {
                            short: 'Júl',
                            long: 'Júl',
                        },

                        8: {
                            short: 'Aug',
                            long: 'August',
                        },

                        9: {
                            short: 'Sep',
                            long: 'September',
                        },

                        10: {
                            short: 'Okt',
                            long: 'Október',
                        },

                        11: {
                            short: 'Nov',
                            long: 'November',
                        },

                        12: {
                            short: 'Dec',
                            long: 'December',
                        },
                    }
                },
            },
        },

        messages,
    ),
});

export default Translations;
